let crosses = document.querySelectorAll('.team-cross');
let corners = document.querySelectorAll('.card-corner-clickable');
let team_cards = document.querySelectorAll('.card--team .card-link');

team_cards.forEach(function(card) {
    card.addEventListener('click', function(){
        let parentCard = card.closest('.card--team');
        parentCard?.classList.add('active');
    })
})


crosses.forEach(function(cross) {
    cross.addEventListener('click', function() {
        let parentCard = cross.closest('.card--team');
        parentCard?.classList.remove('active');
    })
})

corners.forEach(function(corner) {
    corner.addEventListener('click', function() {
        let parentCard = corner.closest('.card--team');
        parentCard?.classList.remove('active');
    })
})

